import React, { useEffect } from "react";
import "./App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Hero } from "./components/Hero";
import { MenuSection } from "./components/MenuSection";
import { GallerySection } from "./components/GallerySection";
import { InfoSection } from "./components/InfoSection";
import { Footer } from "./components/Footer";
import TraiteurPage from "./pages/TraiteurPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  return (
    <>
      <Navigation />
      <Hero />
      <MenuSection />
      <GallerySection />
      <InfoSection />
      <Footer />
    </>
  );
};

function App() {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/traiteur" element={<TraiteurPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
